import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas, useThree, useFrame } from '@react-three/fiber'
import Experience from './Experience.jsx'

import { AdaptiveDpr, useProgress, Html, Preload} from '@react-three/drei'
import { useState, useEffect, useRef } from "react";
import { Suspense, } from 'react'
import loaderGif from '/Textures/dance.gif'; // adjust the path accordingly
import { ModalProvider } from './ModalContext.jsx'
import { useModal } from './ModalContext.jsx'
import Modal from './Modal.jsx'
import Prewarm from './Prewarm.jsx'
import { SRGBColorSpace, ACESFilmicToneMapping } from 'three'
import { Leva } from 'leva'

const ADMIN = new URLSearchParams(window.location.search).has('admin')   // styling dashboard only with ?admin


const root = ReactDOM.createRoot(document.querySelector('#root'))

function Loader() {
    //const { active, progress, errors, item, loaded, total } = useProgress()
    return <Html center><div className="loader-container"> <span className="loader-class"><img src={loaderGif} alt="Loading..." style={{ mixBlendMode: 'multiply' }}/>
    </span> </div></Html>
        // className="loader-class">Loading</Html>
  }
  
function ExposureSetter({ exposure = 1 }) {
    const { gl, size } = useThree()
    const { isOpen } = useModal()
    const apply = useRef(() => {})
    apply.current = () => {
        gl.outputColorSpace = SRGBColorSpace
        gl.toneMapping = ACESFilmicToneMapping
        gl.toneMappingExposure = exposure
    }
    useEffect(() => {
        apply.current()
        // do one more pass on next frame after potential layout/DPR changes
        const id = requestAnimationFrame(() => apply.current())
        const onResize = () => apply.current()
        const onVis = () => apply.current()
        window.addEventListener('resize', onResize)
        document.addEventListener('visibilitychange', onVis)
        return () => {
            cancelAnimationFrame(id)
            window.removeEventListener('resize', onResize)
            document.removeEventListener('visibilitychange', onVis)
        }
    }, [gl, size.width, size.height, exposure])
    // reinforce for a short warm-up to beat any late DPR adjustments
    const warmupFrames = useRef(120)
    const prevIsOpen = useRef(isOpen)
    useEffect(() => {
        // When the modal CLOSES (transition from true -> false), aggressively reapply
        if (prevIsOpen.current && !isOpen) {
            warmupFrames.current = 120
            apply.current()
        }
        prevIsOpen.current = isOpen
    }, [isOpen])
    useFrame(() => {
        if (isOpen || warmupFrames.current > 0) {
            apply.current()
            warmupFrames.current -= 1
        }
    })
    return null
}
  
root.render(
    <ModalProvider>
    <Canvas
        performance={{ min: 0.2 }}
        dpr={[0.5, 1.5]}
        shadows
        gl={{ antialias: false, powerPreference: 'high-performance', stencil: true, depth: true,

            outputColorSpace: SRGBColorSpace,
            toneMapping: ACESFilmicToneMapping,
            toneMappingExposure: 1,
        }}
        camera={ {
            fov: 30,
            near: 5,
            far: 300,
            position: [ 0, 30, 65 ]
        } }
        >
        <Suspense fallback={<Loader/>}>    
        <AdaptiveDpr pixelated />
        <ExposureSetter exposure={2.5} />
        <Experience/>
        </Suspense>
        
    </Canvas>
    <Modal />
    <Prewarm />
    <Leva hidden={!ADMIN} collapsed={false} titleBar={{ title: 'Board styling' }} />
    </ModalProvider>

)